// extracted by mini-css-extract-plugin
export var cardWrapper = "_5q-0";